import { Enrollment } from "@api/types/enrollments";
import { FC } from "react";

const EnrolledCourseDetails: FC<{ enrollment: Enrollment }> = ({ enrollment }) => {
  return (
    <>
      <div className="EnrolledCourseDetails">
        <h2>{enrollment.name}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: enrollment.description,
          }}
        />
      </div>
      {/* language=CSS */}
      <style jsx>
        {`
          .EnrolledCourseDetails {
          }

          h2 {
            font-weight: normal;
            margin-top: 0;
          }
        `}
      </style>
    </>
  );
};

export default EnrolledCourseDetails;
